import { useEffect, useRef, useState } from 'react';
import formatBalance from '../../../helpers/format-balance';
import SidePanel from '../../side-panel/side-panel';
import ButtonPrimary from '../../button/button-primary';
import ButtonPseudo from '../../button/button-pseudo';
import IconLoader from '../../icons/loader';
import { SidePanelType } from '../../side-panel/types';
import {
  BaseellaStatus,
  BlacklistData,
  CustomerType,
  DocumentStatus,
  EnumTabs,
  BlacklistUserInfoData,
} from '../types';
import OutgoingTransactionSidepanelRead from '../incoming-outgoing-transaction-sidepanel-read';
import OutgoingTransactionSidepanelContentForm from './outgoing-transaction-sidepanel-content-form';
import Popup from '../../popup/popup';
import SignaturePopup from '../signature-popup';
import PermissionDenied from '../../permission-denied/permission-denied';
import BlacklistDataContent from '../warnings/blacklist-data-content';
import BlacklistUserInfo from '../warnings/blacklist-user-info';
import { PermissionEnum } from '../../../base-types';
import DocumentSidePanel from '../documents/document-sidepanel';
import ButtonSecondary from '../../button/button-secondary';
import GeneralLedgerSidepanel from '../general-ledger/general-ledger-sidepanel';
import SidePanelLoader from '../../side-panel/loader';
import DateInput from '../../date-input/date-input';
import InputNumber from '../../inputs/input-number';
import Checkbox from '../../checkbox/checkbox';
import IconSelected from '../../icons/selected';
import { OutgoingTransactionSidepanelTypes } from './types';
import usePrevious from '../../../hooks/use-previous';

import styles from '../transaction.module.css';

let changedPaymentTypeHintTimeout: NodeJS.Timeout;

export default function OutgoingTransactionSidepanel({
  tabs,
  panelIsOpen,
  handleClose,
  title,
  statusesInfo,
  onRollbackStatus,
  onNextStatus,
  updateBalance,
  handleSubmit,
  isLoading,
  enableEdit = false,
  control,
  isDisabledSaveButton,
  transactionInfo,
  balanceIsLoading,
  amlInfo,
  currencies,
  senderAccounts,
  pspPartnerAccounts,
  paymentsTypes,
  chargeTypes,
  countries,
  beneficiaryTypes,
  children,
  isCreateForm = false,
  isEditable = true,
  errors,
  onSearchAutocomplete,
  pspPartnersIsLoading,
  senderAccountsIsLoading,
  pspPartnerAccountsIsLoading,
  pspPartnerIsFilled = false,
  paymentTypeIsFilled = false,
  pspPartners,
  baseellaStatus,
  logs,
  changeLogs,
  onScrollToPaymentType,
  paymentType,
  feeText,
  checkError,
  warnings,
  employee,
  onApplyTransactionAction,
  accountBalance,
  currencyId,
  updatePspPartnerBalance,
  pspPartnerAccountBalance,
  pspPartnerBalanceIsLoading,
  isDirty,
  checkInProgress,
  onChangeStatusPopup,
  statusPopupVisible,
  setStatusPopupVisible,
  validateCode,
  signaturePopupVisible,
  sendCode,
  validateCodeInProgress,
  transactionId,
  signatures,
  errorSidepanel,
  setRejectPopupVisible,
  onReject,
  rejectInProgress,
  rejectPopupVisible,
  errorMessageSignature,
  createAllowed,
  transactionsTypes,
  updateStatusIsLoading,
  isLoadingStatuses,
  transactionCheckError,
  onSignatureCancelClick,
  activePermission,
  amount,
  setAmount,
  latestQueuedStatus,
  createdByOrganizationId,
  statusChangeError,
  onChangeStatusPopupLoading,
  applyTransactionsWarningIsLoading,
  chats,
  companyOfficials,
  onCreateTransactionChat,
  chatCreateInProgress,
  currentEmployee,
  createChatWithMessage,
  documents,
  document: documentItem,
  documentFileIsLoading,
  downloadInProgress,
  imgLink,
  onDelete,
  deleteInProgress,
  onMove,
  moveInProgress,
  onDownload,
  deleteIsVisible,
  sendComment,
  editComment,
  editCommentInProgress,
  editCommentIsSuccess,
  deleteComment,
  deleteCommentInProgress,
  commentInProgress,
  statusChangeInProgress,
  changeCustomerDocumentsStatus,
  onUploadDocument,
  uploadDocumentInProgress,
  uploadDocumentIsSuccess,
  uploadDocumentErrors,
  onDownloadSuccess,
  glTransactionsIsLoading,
  glTransactions,
  onGlTransactionClick,
  glTransactionIsLoading,
  glTransaction,
  clearGlTransactionState,
  getTransactionDocument,
  documentIsLoading,
  deleteIsSuccess,
  sendMessage,
  expandedGLTransactionCreditBalance,
  expandedGLTransactionDebitBalance,
  expendedDebitBalanceIsLoading,
  expendedCreditBalanceIsLoading,
  deleteTransactionError,
  onDeleteTransactions,
  deleteTransactionInProgress,
  deleteTransactionDisabled,
  createIsLoading,
  updateIsLoading,
  internalError,
  canSignTransaction,
  sendCodeInProgress,
  balances,
  accountBalancesIsLoading,
  currenciesList,
  onDuplicate,
  duplicate,
  baseCurrencyName,
  fields,
  caspList,
  getTransactionDocuments,
  documentsIsLoading,
  getGeneralLedgerTransactionValues,
  getTransactionsChats,
  transactionChatsIsLoading,
  getCompanyOfficials,
  getSignaturesTransactionById,
  isLoadingSignatures,
  getOutgoingTransactionByIdAml,
  isLoadingAml,
  getLogsTransactionById,
  isLoadingLogs,
  overdraftEnabled,
  senderAccountsWithInfo,
  pspPartnersAccountsList,
  pspPartnerAccountBalanceInfo,
  getTransactionChangeLogs,
  changeLogsIsLoading,
  users,
  transactionChangeLogsPagination,
  changeLogsIsFetching,
  refundPopupVisible,
  setRefundPopupVisible,
  onChangeRefundState,
  refundFormState,
  refundInProgress,
  onRefund,
  refundAmountError,
  setRefundAmountError,
  onResetTransactionWarningAction,
  resetTransactionsWarningIsLoading,
  resetTransactionsWarningIsSuccess,
  sidepanelExpandedKey,
  documentsPagination,
  documentsIsFetching,
  attachedDocumentsErrors,
  uploadedDocumentsErrors,
  transactionComments,
  transactionCommentsPagination,
  getTransactionCommentsAction,
  commentsIsLoading,
  commentsIsFetching,
  onAddCommentToTransaction,
  addCommentInProgress,
  addCommentIsSuccess,
  onEditCommentInTransaction,
  editTransactionCommentInProgress,
  editTrancastionCommentIsSuccess,
  onDeleteCommentInTransaction,
  deleteCommentInTransactionInProgress,
  deleteCommentInTranscationIsSuccess,
  getOutgoingTransactionWarningById,
  isWarningByIdFetching,
  isWarningByIdLoading,
  warningsInfo,
  ibanValidationAvailable,
  onValidateIban,
  ibanValidationValues,
  ibanValidationIsLoading,
  setValue,
  bicSearchAvailable,
  bicValidationAvailable,
  onSearchBic,
  onBicValidate,
  bicSearchIsLoading,
  beneficairyBicSearchResults,
  intermediaryBicSearchResults,
  selectedValidationType,
  bicValidationIntermediaryResult,
  bicValidationBeneficiaryResult,
  bicValidationIsLoading,
  countriesList,
  setBicValidationBeneficiaryResult,
  setError,
  clearErrors,
  setIbanValidationValues,
  selectedWarningId,
  getIntegrationLogs,
  integrationLogsIsLoading,
  integrationLogsIsFetching,
  integrationLogs,
  integrationLogsPagination,
  pspPartnerAccountsNextPageIsLoading,
  pspPartnerAccountsOnScroll,
  pspPartnerAccountsPagination,
  externalAccounts,
  externalAccountsIsLoading,
  onSearchExternalAccounts,
  onClearExternalAccounts,
  onGetExternalAccountsListAction,
  externalAccountsPagination,
  externalAccountsNextPageIsLoading,
  updateExternalBalance,
  purposeCodeVisible,
  purposeCodes,
  purposeCodesIsLoading,
  purposeCodesNextPageIsLoading,
  onScrollPurposeCodes,
  purposeCodesPagination,
  warningActionError,
  deleteDisabled,
}: OutgoingTransactionSidepanelTypes): React.JSX.Element {
  const [dirtyPopupVisible, setDirtyPopupVisible] = useState(false);
  const [blacklistDataVisible, setBlacklistDataVisible] = useState(false);
  const [blacklistData, setBlacklistData] = useState<BlacklistData>();
  const [transactionSidePanelVisible, setTransactionSidepanelVisible] =
    useState(panelIsOpen);
  const [selectedDocumentName, setSelectedDocumentName] = useState('');
  const [subPanelVisible, setSubPanelVisible] = useState(false);
  const [scroll, setScroll] = useState(0);
  const scrollRef = useRef<HTMLDivElement | null>(null);
  const [deletePopupVisible, setDeletePopupVisible] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState<
    DocumentStatus | undefined
  >(undefined);
  const [glTransactionSidepanelVisible, setGlTransactionSidePanelVisible] =
    useState(false);
  const [selectedDocumentId, setSelectedDocumentId] = useState('');
  const [activeTab, setActiveTab] = useState(EnumTabs.GENERAL);
  const [deleteTransactionPopupVisible, setDeleteTransactionPopupVisible] =
    useState(false);
  const [blacklistItem, setBlacklistDataItem] =
    useState<BlacklistUserInfoData>();
  const [blacklistItemVisible, setBlacklistItemVisible] = useState(false);
  const [changedPaymentType, setChangedPaymentType] = useState('');
  const [changedPaymentTypeHintVisible, setChangedPaymentTypeHintVisible] =
    useState(false);
  const [confirmationPopupVisible, setConfirmationPopupVisible] =
    useState(false);

  const prevEditInProgress = usePrevious(updateIsLoading);

  const tabsItems = isCreateForm
    ? [
        { name: 'General Info', value: EnumTabs.GENERAL },
        { name: 'Order', value: EnumTabs.ORDER },
      ]
    : [
        { name: 'General Info', value: EnumTabs.GENERAL },
        { name: 'Order', value: EnumTabs.ORDER },
        { name: 'Warning', value: EnumTabs.WARNING },
        { name: 'AML & KYC', value: EnumTabs.AML },
        { name: 'Status log', value: EnumTabs.LOG },
        { name: 'Change Log', value: EnumTabs.CHANGE_LOG },
        { name: 'Signatures', value: EnumTabs.SIGNATURES },
        { name: 'Documents', value: EnumTabs.DOCUMENTS },
        { name: 'Accounting entries', value: EnumTabs.GL_TRANSACTIONS },
        { name: 'Chats', value: EnumTabs.CHATS },
        { name: 'Comments', value: EnumTabs.COMMENTS },
        { name: 'Integration Logs', value: EnumTabs.INTEGRATION_LOGS },
      ];

  let content;
  let contentError;

  const handleCloseBlacklistData = () => {
    setBlacklistDataVisible(false);
    setBlacklistItemVisible(false);
    setBlacklistData(undefined);
    setBlacklistDataItem(undefined);
    setTransactionSidepanelVisible(true);
  };

  useEffect(() => {
    setTransactionSidepanelVisible(panelIsOpen);
  }, [panelIsOpen, isLoading]);

  const handleScroll = () => {
    setScroll((prev) => {
      if (prev !== Number(scrollRef.current?.scrollTop)) {
        return Number(scrollRef.current?.scrollTop);
      }
      return prev;
    });
  };

  useEffect(() => {
    const element = scrollRef.current;

    element?.addEventListener('scroll', handleScroll);

    return () => {
      element?.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    if (onDownloadSuccess && selectedDocumentId && !downloadInProgress) {
      setSelectedDocumentId('');
    }
  }, [onDownloadSuccess, selectedDocumentId, downloadInProgress]);

  useEffect(() => {
    if (deleteIsSuccess) {
      setDeletePopupVisible(false);
      setSubPanelVisible(false);
      setTransactionSidepanelVisible(true);
      setActiveTab(EnumTabs.DOCUMENTS);
    }
  }, [deleteIsSuccess]);

  useEffect(() => {
    if (changedPaymentTypeHintVisible) {
      changedPaymentTypeHintTimeout = setTimeout(() => {
        setChangedPaymentTypeHintVisible(false);

        clearTimeout(changedPaymentTypeHintTimeout);
      }, 5000);
    }
  }, [changedPaymentTypeHintVisible]);

  useEffect(() => {
    if (!updateIsLoading && prevEditInProgress) {
      setConfirmationPopupVisible(false);
    }
  }, [updateIsLoading, prevEditInProgress]);

  if (checkError) {
    contentError = checkError;
  } else if (errors) {
    contentError = 'There are errors in some fields';
  } else if (errorSidepanel) {
    contentError = errorSidepanel;
  } else if (deleteTransactionError) {
    contentError = deleteTransactionError;
  }

  if (isLoading && !internalError) {
    content = (
      <div className={styles.loaderWrapper}>
        <IconLoader />
      </div>
    );
  } else if (enableEdit && !internalError) {
    if ((isCreateForm && createAllowed) || transactionId) {
      content = (
        <OutgoingTransactionSidepanelContentForm
          statusesInfo={statusesInfo}
          onNextStatus={onNextStatus}
          onRollbackStatus={onRollbackStatus}
          control={control}
          transactionInfo={transactionInfo}
          amlInfo={amlInfo}
          currencies={currencies}
          pspPartnerAccounts={pspPartnerAccounts}
          senderAccounts={senderAccounts}
          paymentsTypes={paymentsTypes}
          chargeTypes={chargeTypes}
          beneficiaryTypes={beneficiaryTypes}
          countries={countries}
          isCreateForm={isCreateForm}
          isEditable={isEditable}
          errors={errors}
          onSearchAutocomplete={onSearchAutocomplete}
          pspPartnersIsLoading={pspPartnersIsLoading}
          senderAccountsIsLoading={senderAccountsIsLoading}
          pspPartnerAccountsIsLoading={pspPartnerAccountsIsLoading}
          pspPartnerIsFilled={pspPartnerIsFilled}
          paymentTypeIsFilled={paymentTypeIsFilled}
          pspPartners={pspPartners}
          baseellaStatus={baseellaStatus}
          logs={logs}
          onScrollToPaymentType={onScrollToPaymentType}
          paymentType={paymentType}
          feeText={feeText}
          warnings={warnings}
          employee={employee}
          onApplyTransactionAction={onApplyTransactionAction}
          changeLogs={changeLogs}
          accountBalance={accountBalance}
          currencyId={currencyId}
          balanceIsLoading={balanceIsLoading}
          updateBalance={updateBalance}
          updatePspPartnerBalance={updatePspPartnerBalance}
          pspPartnerBalanceIsLoading={pspPartnerBalanceIsLoading}
          pspPartnerAccountBalance={pspPartnerAccountBalance}
          signatures={signatures}
          sendCode={sendCode}
          sendCodeInProgress={sendCodeInProgress}
          setRejectPopupVisible={setRejectPopupVisible}
          transactionsTypes={transactionsTypes}
          setBlacklistDataVisible={(visible) => {
            setBlacklistDataVisible(visible);
            setTransactionSidepanelVisible(false);
          }}
          setBlacklistItemVisible={(visible) => {
            setBlacklistItemVisible(visible);
            setTransactionSidepanelVisible(false);
          }}
          setBlacklistData={setBlacklistData}
          setBlacklistDataItem={setBlacklistDataItem}
          parentRef={scrollRef}
          parentScroll={scroll}
          updateStatusIsLoading={updateStatusIsLoading}
          isLoadingStatuses={isLoadingStatuses}
          activePermission={activePermission}
          amount={amount}
          setAmount={setAmount}
          latestQueuedStatus={latestQueuedStatus}
          createdByOrganizationId={createdByOrganizationId}
          applyTransactionsWarningIsLoading={applyTransactionsWarningIsLoading}
          companyOfficials={companyOfficials}
          chats={chats}
          onCreateTransactionChat={onCreateTransactionChat}
          chatCreateInProgress={chatCreateInProgress}
          currentEmployee={currentEmployee}
          createChatWithMessage={createChatWithMessage}
          documents={documents}
          setSubPanelVisible={setSubPanelVisible}
          uploadDocumentInProgress={uploadDocumentInProgress}
          uploadDocumentIsSuccess={uploadDocumentIsSuccess}
          setSelectedDocumentName={setSelectedDocumentName}
          setTransactionSidepanelVisible={setTransactionSidepanelVisible}
          onUploadDocument={onUploadDocument}
          uploadDocumentErrors={uploadDocumentErrors}
          selectedDocumentId={selectedDocumentId}
          setSelectedDocumentId={setSelectedDocumentId}
          downloadInProgress={documentFileIsLoading || downloadInProgress}
          tabs={tabsItems}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          glTransactionsIsLoading={glTransactionsIsLoading}
          glTransactions={glTransactions}
          setGlTransactionSidePanelVisible={setGlTransactionSidePanelVisible}
          onGlTransactionClick={onGlTransactionClick}
          onDownloadDocument={onDownload}
          getTransactionDocument={getTransactionDocument}
          canSignTransaction={canSignTransaction}
          balances={balances}
          accountBalancesIsLoading={accountBalancesIsLoading}
          currenciesList={currenciesList}
          duplicate={duplicate}
          baseCurrencyName={baseCurrencyName}
          fields={fields}
          caspList={caspList}
          getTransactionDocuments={getTransactionDocuments}
          documentsIsLoading={documentsIsLoading}
          getGeneralLedgerTransactionValues={getGeneralLedgerTransactionValues}
          getTransactionsChats={getTransactionsChats}
          transactionChatsIsLoading={transactionChatsIsLoading}
          getCompanyOfficials={getCompanyOfficials}
          getSignaturesTransactionById={getSignaturesTransactionById}
          isLoadingSignatures={isLoadingSignatures}
          getOutgoingTransactionByIdAml={getOutgoingTransactionByIdAml}
          isLoadingAml={isLoadingAml}
          getLogsTransactionById={getLogsTransactionById}
          isLoadingLogs={isLoadingLogs}
          overdraftEnabled={overdraftEnabled}
          senderAccountsWithInfo={senderAccountsWithInfo}
          pspPartnersAccountsList={pspPartnersAccountsList}
          pspPartnerAccountBalanceInfo={pspPartnerAccountBalanceInfo}
          getTransactionChangeLogs={getTransactionChangeLogs}
          changeLogsIsLoading={changeLogsIsLoading}
          users={users}
          transactionChangeLogsPagination={transactionChangeLogsPagination}
          changeLogsIsFetching={changeLogsIsFetching}
          transactionId={transactionId}
          onResetTransactionWarningAction={onResetTransactionWarningAction}
          resetTransactionsWarningIsLoading={resetTransactionsWarningIsLoading}
          resetTransactionsWarningIsSuccess={resetTransactionsWarningIsSuccess}
          documentsPagination={documentsPagination}
          documentsIsFetching={documentsIsFetching}
          attachedDocumentsErrors={attachedDocumentsErrors}
          uploadedDocumentsErrors={uploadedDocumentsErrors}
          transactionComments={transactionComments}
          transactionCommentsPagination={transactionCommentsPagination}
          getTransactionCommentsAction={getTransactionCommentsAction}
          commentsIsLoading={commentsIsLoading}
          commentsIsFetching={commentsIsFetching}
          onAddCommentToTransaction={onAddCommentToTransaction}
          addCommentInProgress={addCommentInProgress}
          addCommentIsSuccess={addCommentIsSuccess}
          onEditCommentInTransaction={onEditCommentInTransaction}
          editTransactionCommentInProgress={editTransactionCommentInProgress}
          editTrancastionCommentIsSuccess={editTrancastionCommentIsSuccess}
          onDeleteCommentInTransaction={onDeleteCommentInTransaction}
          deleteCommentInTransactionInProgress={
            deleteCommentInTransactionInProgress
          }
          deleteCommentInTranscationIsSuccess={
            deleteCommentInTranscationIsSuccess
          }
          getOutgoingTransactionWarningById={getOutgoingTransactionWarningById}
          isWarningByIdFetching={isWarningByIdFetching}
          isWarningByIdLoading={isWarningByIdLoading}
          warningsInfo={warningsInfo}
          ibanValidationAvailable={ibanValidationAvailable}
          onValidateIban={onValidateIban}
          ibanValidationValues={ibanValidationValues}
          ibanValidationIsLoading={ibanValidationIsLoading}
          setValue={setValue}
          bicSearchAvailable={bicSearchAvailable}
          bicValidationAvailable={bicValidationAvailable}
          onSearchBic={onSearchBic}
          onBicValidate={onBicValidate}
          bicSearchIsLoading={bicSearchIsLoading}
          beneficairyBicSearchResults={beneficairyBicSearchResults}
          intermediaryBicSearchResults={intermediaryBicSearchResults}
          selectedValidationType={selectedValidationType}
          bicValidationIntermediaryResult={bicValidationIntermediaryResult}
          bicValidationBeneficiaryResult={bicValidationBeneficiaryResult}
          bicValidationIsLoading={bicValidationIsLoading}
          countriesList={countriesList}
          setChangedPaymentType={setChangedPaymentType}
          setChangedPaymentTypeHintVisible={setChangedPaymentTypeHintVisible}
          setBicValidationBeneficiaryResult={setBicValidationBeneficiaryResult}
          setError={setError}
          clearErrors={clearErrors}
          setIbanValidationValues={setIbanValidationValues}
          selectedWarningId={selectedWarningId}
          getIntegrationLogs={getIntegrationLogs}
          integrationLogsIsLoading={integrationLogsIsLoading}
          integrationLogsIsFetching={integrationLogsIsFetching}
          integrationLogs={integrationLogs}
          integrationLogsPagination={integrationLogsPagination}
          pspPartnerAccountsNextPageIsLoading={
            pspPartnerAccountsNextPageIsLoading
          }
          pspPartnerAccountsOnScroll={pspPartnerAccountsOnScroll}
          pspPartnerAccountsPagination={pspPartnerAccountsPagination}
          externalAccounts={externalAccounts}
          externalAccountsIsLoading={externalAccountsIsLoading}
          updateExternalBalance={updateExternalBalance}
          onSearchExternalAccounts={onSearchExternalAccounts}
          onClearExternalAccounts={onClearExternalAccounts}
          onGetExternalAccountsListAction={onGetExternalAccountsListAction}
          externalAccountsPagination={externalAccountsPagination}
          externalAccountsNextPageIsLoading={externalAccountsNextPageIsLoading}
          purposeCodeVisible={purposeCodeVisible}
          purposeCodes={purposeCodes}
          purposeCodesIsLoading={purposeCodesIsLoading}
          purposeCodesNextPageIsLoading={purposeCodesNextPageIsLoading}
          onScrollPurposeCodes={onScrollPurposeCodes}
          purposeCodesPagination={purposeCodesPagination}
          warningActionError={warningActionError}
        />
      );
    } else if (!createAllowed && isCreateForm) {
      content = <PermissionDenied />;
    }
  } else if (internalError) {
    content = <div className={styles.internalError}>{internalError}</div>;
  } else {
    content = (
      <OutgoingTransactionSidepanelRead
        tabs={tabs}
        parentRef={scrollRef}
        parentScroll={scroll}
        warnings={warnings}
        setSubPanelVisible={setSubPanelVisible}
        setSelectedDocumentName={setSelectedDocumentName}
        getTransactionDocument={getTransactionDocument}
        sendMessage={sendMessage}
        deletedAt={transactionInfo?.deletedAt}
      />
    );
  }

  let footerButton;

  if (baseellaStatus !== BaseellaStatus.NOT_SIGNED && enableEdit) {
    if (transactionId && isEditable) {
      footerButton = (
        <ButtonPrimary
          text="Save"
          disabled={isDisabledSaveButton}
          onClick={() => setConfirmationPopupVisible(true)}
          bold
        />
      );
    } else if (isCreateForm && createAllowed) {
      footerButton = (
        <ButtonPrimary
          text={createIsLoading ? 'Loading...' : 'Save'}
          disabled={isDisabledSaveButton}
          onClick={sendCode}
          bold
        />
      );
    }
  }

  return (
    <>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={transactionSidePanelVisible}
        onClose={isDirty ? () => setDirtyPopupVisible(true) : handleClose}
        title={title}
        footerVisible={enableEdit}
        className={styles.transactionSidepanel}
        childrenRef={scrollRef}
        errorSidepanel={contentError || statusChangeError}
        checkInProgress={checkInProgress}
        transactionCheckError={transactionCheckError}
        checkText="Checking transaction..."
        sidepanelExpandedKey={sidepanelExpandedKey}
        footer={
          <>
            {!internalError && footerButton}
            {!isLoading && (
              <>
                {transactionId && onDuplicate && (
                  <ButtonSecondary
                    text="Duplicate"
                    onClick={onDuplicate}
                    className={styles.duplicateButton}
                    disabled={Boolean(
                      updateStatusIsLoading ||
                      statusChangeInProgress ||
                      deleteTransactionInProgress ||
                      updateIsLoading,
                    )}
                    bold
                  />
                )}
                {!internalError && transactionId && !deleteDisabled && (
                  <ButtonSecondary
                    text={
                      deleteTransactionInProgress
                        ? 'Loading...'
                        : 'Delete transaction'
                    }
                    className={`button-white button-warning ${styles.deleteTransactionButton}`}
                    disabled={
                      deleteTransactionInProgress ||
                      deleteTransactionDisabled ||
                      updateStatusIsLoading ||
                      statusChangeInProgress ||
                      deleteTransactionInProgress ||
                      updateIsLoading
                    }
                    onClick={() => setDeleteTransactionPopupVisible(true)}
                    bold
                  />
                )}
              </>
            )}

            <ButtonPseudo text="Cancel" onClick={handleClose} bold />
          </>
        }
      >
        <>
          {children}
          {content}
        </>
      </SidePanel>

      <GeneralLedgerSidepanel
        panelIsOpen={glTransactionSidepanelVisible}
        handleClose={() => {
          if (clearGlTransactionState) {
            clearGlTransactionState();
          }
          setTransactionSidepanelVisible(true);

          setGlTransactionSidePanelVisible(false);
          setActiveTab(EnumTabs.GL_TRANSACTIONS);
        }}
        transaction={glTransaction}
        isLoading={glTransactionIsLoading as boolean}
        title="GL Transaction"
        debitAccountBalance={expandedGLTransactionDebitBalance}
        creditAccountBalance={expandedGLTransactionCreditBalance}
        debitBalanceIsLoading={expendedDebitBalanceIsLoading}
        creditBalanceIsLoading={expendedCreditBalanceIsLoading}
        sidepanelExpandedKey="outgoing-gl-transaction"
      />
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={subPanelVisible}
        onClose={() => {
          setSubPanelVisible(false);
          setSelectedDocumentName('');
          setTransactionSidepanelVisible(true);
          setActiveTab(EnumTabs.DOCUMENTS);
        }}
        title={selectedDocumentName}
        className={styles.subPanel}
        sidepanelExpandedKey="outgoing-documents"
        footer={
          <>
            {((transactionInfo?.senderAccount?.organization?.type ===
              CustomerType.INDIVIDUAL &&
              activePermission?.includes(
                PermissionEnum.INDIVIDUAL_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
              )) ||
              (transactionInfo?.senderAccount?.organization?.type ===
                CustomerType.CORPORATE &&
                activePermission?.includes(
                  PermissionEnum.CORPORATE_CUSTOMERS_DOCUMENTS_UPDATE_STATUS_ACTION,
                ))) &&
              documentItem && (
                <>
                  {documentItem.status !== DocumentStatus.ACCEPTED &&
                    documentItem.status !== DocumentStatus.EXPIRED && (
                      <ButtonSecondary
                        text={
                          statusChangeInProgress &&
                          selectedStatus === DocumentStatus.ACCEPTED
                            ? 'Loading...'
                            : 'Accept'
                        }
                        onClick={() => {
                          setSelectedStatus(DocumentStatus.ACCEPTED);

                          if (changeCustomerDocumentsStatus) {
                            changeCustomerDocumentsStatus({
                              ids: [documentItem?.id],
                              status: DocumentStatus.ACCEPTED,
                            });
                          }
                        }}
                        disabled={statusChangeInProgress || documentIsLoading}
                        bold
                      />
                    )}
                  {documentItem.status !== DocumentStatus.REJECTED &&
                    documentItem.status !== DocumentStatus.EXPIRED && (
                      <ButtonSecondary
                        text={
                          statusChangeInProgress &&
                          selectedStatus === DocumentStatus.REJECTED
                            ? 'Loading...'
                            : 'Reject'
                        }
                        className={styles.rejectStatusButton}
                        onClick={() => {
                          setSelectedStatus(DocumentStatus.REJECTED);

                          if (changeCustomerDocumentsStatus) {
                            changeCustomerDocumentsStatus({
                              ids: [documentItem?.id],
                              status: DocumentStatus.REJECTED,
                            });
                          }
                        }}
                        disabled={statusChangeInProgress || documentIsLoading}
                        bold
                      />
                    )}
                </>
              )}
            <ButtonPseudo
              text="Close"
              onClick={() => {
                setSubPanelVisible(false);
                setSelectedDocumentName('');
                setTransactionSidepanelVisible(true);
                setActiveTab(EnumTabs.DOCUMENTS);
              }}
              className="button-white"
              bold
            />
          </>
        }
      >
        {documentIsLoading ? (
          <SidePanelLoader />
        ) : (
          <DocumentSidePanel
            document={documentItem}
            documentFileIsLoading={documentFileIsLoading}
            downloadInProgress={downloadInProgress}
            imgLink={imgLink}
            setDeletePopupVisible={setDeletePopupVisible}
            onMove={onMove}
            moveInProgress={moveInProgress}
            onDownload={onDownload}
            deleteIsVisible={deleteIsVisible}
            customerType={transactionInfo?.senderAccount?.organization?.type}
            commentsVisible={activePermission?.includes(
              PermissionEnum.DOCUMENTS_COMMENTS_ACTION,
            )}
            sendComment={sendComment}
            editComment={editComment}
            editCommentInProgress={editCommentInProgress}
            editCommentIsSuccess={editCommentIsSuccess}
            deleteComment={deleteComment}
            deleteCommentInProgress={deleteCommentInProgress}
            commentInProgress={commentInProgress}
            activePermissions={activePermission}
            onDownloadSuccess={onDownloadSuccess}
          />
        )}
      </SidePanel>
      <Popup
        title="Delete transaction?"
        onCancelClick={() => setDeleteTransactionPopupVisible(false)}
        onOkClick={() =>
          onDeleteTransactions && onDeleteTransactions(transactionId as string)
        }
        cancelButtonText="Cancel"
        okButtonText={deleteTransactionInProgress ? 'Loading...' : 'Delete'}
        isVisible={deleteTransactionPopupVisible}
        isLoading={deleteTransactionInProgress}
        parent={document.getElementById('signature-popup') as HTMLElement}
      >
        <div>
          {deleteTransactionError && (
            <div className={styles.transactionDeleteError}>
              {deleteTransactionError}
            </div>
          )}
        </div>
      </Popup>
      <Popup
        title={`Delete ${documentItem?.name}`}
        onCancelClick={() => setDeletePopupVisible(false)}
        onOkClick={() => onDelete && onDelete(documentItem?.id as string)}
        okButtonText={deleteInProgress ? 'Loading...' : 'Delete'}
        cancelButtonText="Cancel"
        isVisible={deletePopupVisible}
        isLoading={deleteInProgress}
        parent={document.getElementById('delete-popup-wrapper') as HTMLElement}
      />
      <Popup
        title="You have unsaved changes that will be lost"
        description="Are you sure you want to close this form?"
        onCancelClick={() => setDirtyPopupVisible(false)}
        onOkClick={handleClose}
        cancelButtonText="Cancel"
        okButtonText="Close"
        isVisible={dirtyPopupVisible}
        parent={document.getElementById('dirty-popup') as HTMLElement}
      />
      <Popup
        title="Refund transaction"
        onCancelClick={() =>
          setRefundPopupVisible && setRefundPopupVisible(false)
        }
        onOkClick={onRefund}
        cancelButtonText="Cancel"
        okButtonText={refundInProgress ? 'Loading...' : 'Refund'}
        isVisible={refundPopupVisible as boolean}
        popupClassName={styles.refundPopup}
        parent={document.getElementById('dirty-popup') as HTMLElement}
        isLoading={refundInProgress}
        okButtonDisabled={
          !refundFormState?.refundAmount ||
          !refundFormState?.refundedAt ||
          Boolean(refundAmountError)
        }
      >
        <div className={styles.refundForm}>
          <div className={styles.refundFormGroup}>
            <DateInput
              title="Refund Date"
              value={refundFormState?.refundedAt}
              onChange={(e) => {
                if (
                  refundAmountError &&
                  refundAmountError?.includes('date') &&
                  new Date(e.toISOString()).getTime() < new Date().getTime()
                ) {
                  if (setRefundAmountError) {
                    setRefundAmountError('');
                  }
                }

                if (onChangeRefundState) {
                  onChangeRefundState({
                    name: 'refundedAt',
                    value: e.toISOString(),
                  });
                }
              }}
              className={styles.refundDate}
              placeholder="Select refund date"
              onReset={() => {
                if (onChangeRefundState) {
                  onChangeRefundState({
                    name: 'refundedAt',
                    value: '',
                  });
                }
              }}
              withoutCustomSelector
            />
          </div>
          <div className={styles.refundFormGroup}>
            <InputNumber
              name="refundAmount"
              value={refundFormState?.refundAmount}
              title="Refund Amount"
              placeholder="Enter refund amount"
              onChange={(e) => {
                if (onChangeRefundState) {
                  if (Number(e.target.value) > Number(transactionInfo?.sum)) {
                    if (setRefundAmountError) {
                      setRefundAmountError(
                        'Refund amount must be less or equal than transaction sum',
                      );
                    }
                  } else if (Number(e.target.value) < 0) {
                    if (setRefundAmountError) {
                      setRefundAmountError('Refund amount must be positive');
                    }
                  } else {
                    // eslint-disable-next-line no-lonely-if
                    if (setRefundAmountError) {
                      setRefundAmountError('');
                    }
                  }

                  onChangeRefundState({
                    name: 'refundAmount',
                    value: e.target.value,
                  });
                }
              }}
            />
            {refundAmountError && (
              <div className={styles.refundAmountError}>
                {refundAmountError}
              </div>
            )}
            {transactionInfo?.sum && (
              <button
                type="button"
                className={styles.fullAmoutButton}
                onClick={() => {
                  if (
                    refundAmountError &&
                    refundAmountError?.includes('amount')
                  ) {
                    if (setRefundAmountError) {
                      setRefundAmountError('');
                    }
                  }

                  if (onChangeRefundState) {
                    onChangeRefundState({
                      name: 'refundAmount',
                      value: transactionInfo?.sum?.toString(),
                    });
                  }
                }}
              >{`Full amount ${formatBalance(
                transactionInfo?.sum,
                transactionInfo?.currency,
              )}`}</button>
            )}
          </div>
          <div className={styles.refundFeesWrapper}>
            <div className={styles.refundFee}>
              <Checkbox
                name="refundFees"
                type="radio"
                checked={refundFormState?.refundFees}
                title="Refund fee"
                onChange={() => {
                  if (onChangeRefundState) {
                    onChangeRefundState({
                      name: 'refundFees',
                      value: true,
                    });
                  }
                }}
              />
            </div>
            <div className={styles.refundFee}>
              <Checkbox
                name="notRefundFees"
                type="radio"
                checked={!refundFormState?.refundFees}
                title="Do not refund fee"
                onChange={() => {
                  if (onChangeRefundState) {
                    onChangeRefundState({
                      name: 'refundFees',
                      value: false,
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>
      </Popup>
      <Popup
        title="You have unsaved changed"
        description="You want to change the status of a transaction, but you have unsaved changes on the transaction. Please select one of the following options:"
        onCancelClick={() =>
          setStatusPopupVisible && setStatusPopupVisible(false)
        }
        onOkClick={onChangeStatusPopup}
        isLoading={onChangeStatusPopupLoading}
        cancelButtonText="Cancel"
        okButtonText="Save changes and change status"
        isVisible={Boolean(statusPopupVisible)}
        parent={document.getElementById('status-popup') as HTMLElement}
      />
      <SignaturePopup
        signaturePopupVisible={signaturePopupVisible}
        validateCode={validateCode}
        validateCodeInProgress={validateCodeInProgress}
        errorMessageSignature={errorMessageSignature}
        onSignatureCancelClick={onSignatureCancelClick}
      />
      <Popup
        title="The transaction will be rejected"
        onCancelClick={() =>
          setRejectPopupVisible && setRejectPopupVisible(false)
        }
        onOkClick={onReject}
        cancelButtonText="Cancel"
        okButtonText="Yes, Reject"
        isVisible={rejectPopupVisible as boolean}
        parent={document.getElementById('signature-popup') as HTMLElement}
        isLoading={rejectInProgress}
      />
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={blacklistDataVisible}
        onClose={handleCloseBlacklistData}
        title={blacklistData?.fullName as string}
        parent={
          document.getElementById('blacklist-data-sidepanel') as HTMLElement
        }
        className={styles.transactionSidepanel}
        footer={
          <ButtonPseudo text="Close" onClick={handleCloseBlacklistData} bold />
        }
        sidepanelExpandedKey="outgoing-blacklist-data"
      >
        <BlacklistDataContent data={blacklistData} />
      </SidePanel>
      <SidePanel
        type={SidePanelType.Transactions}
        closeOnClickOutside
        isOpen={blacklistItemVisible}
        onClose={handleCloseBlacklistData}
        title="User Details"
        parent={
          document.getElementById('blacklist-data-sidepanel') as HTMLElement
        }
        className={styles.transactionSidepanel}
        footer={
          <ButtonPseudo text="Close" onClick={handleCloseBlacklistData} bold />
        }
        sidepanelExpandedKey="outgoing-blacklist-data"
        withoutExpand
        expanded
      >
        <BlacklistUserInfo info={blacklistItem} isLoading={false} />
      </SidePanel>
      {changedPaymentTypeHintVisible && (
        <div className={styles.paymentTypeChangedHint}>
          <div className={styles.paymentTypeChangedHintLeft}>
            <div className={styles.paymentTypeChangedHintIcon}>
              <IconSelected width={18} height={18} />
            </div>
            <div className={styles.paymentTypeChangedHintText}>
              The payment type has been changed to&nbsp;{changedPaymentType}
            </div>
          </div>
          <div className={styles.closeButtonWrapper}>
            <ButtonPseudo
              text="Close"
              className="button-white"
              onClick={() => {
                setChangedPaymentTypeHintVisible(false);
                clearTimeout(changedPaymentTypeHintTimeout);
              }}
              bold
            />
          </div>
        </div>
      )}
      <Popup
        title="Are you sure to save all changes?"
        onCancelClick={() => setConfirmationPopupVisible(false)}
        onOkClick={handleSubmit}
        isLoading={updateIsLoading}
        cancelButtonText="Cancel"
        okButtonText={updateIsLoading ? 'Loading...' : 'Save changes'}
        isVisible={confirmationPopupVisible}
        parent={document.getElementById('status-popup') as HTMLElement}
        okButtonDisabled={updateIsLoading}
      />
      <div id="status-popup" />
      <div id="dirty-popup" />
      <div id="signature-popup" />
      <div id="blacklist-data-sidepanel" />
      <div id="delete-popup-wrapper" />
    </>
  );
}
